import React from "react";
import {T, useTranslate} from "@tolgee/react";
import FlexBox from "view/components/Layout/FlexBox";
import {Button, CircularProgress, Typography} from "@material-ui/core";
import {
  useFormActionsContext,
  useFormStateContext,
} from "view/SignUp/SignUpToken/context";
import LoginLink from "view/SignUp/SignUpToken/components/LoginLink";
import {KeyboardBackspaceSharp} from "@material-ui/icons";

type Props = {
  isSubmitDisabled: boolean;
  isSubmitting: boolean;
};

const ButtonGroup = ({isSubmitDisabled, isSubmitting}: Props) => {
  const {t} = useTranslate();
  const {prevStep} = useFormActionsContext();
  const {activeStep: step} = useFormStateContext();
  const Icon = isSubmitting ? CircularProgress : KeyboardBackspaceSharp;
  const submitButtonText =
    step === 0 ? t("common.action.next") : t("global.sign_up.sign_up");

  return (
    <FlexBox gap={1.5} justifyContent="space-between">
      <FlexBox alignCenter>
        <Typography color="primary" variant="h4">
          {step === 1 && (
            <T keyName="global.sign_up.already_have_account_question" />
          )}
          <LoginLink>
            <T keyName="global.sign_up.log_in" />
          </LoginLink>
        </Typography>
      </FlexBox>
      <FlexBox gap={2}>
        {step > 0 && (
          <Button onClick={prevStep} variant="text" color="primary">
            <KeyboardBackspaceSharp style={{marginRight: 8}} />
            <T keyName="common.action.back" />
          </Button>
        )}
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={isSubmitDisabled}
        >
          {submitButtonText}
          <Icon
            size={16}
            style={{
              marginLeft: 4,
              transform: `rotate(${!isSubmitting ? 180 : 0}deg)`,
            }}
          />
        </Button>
      </FlexBox>
    </FlexBox>
  );
};

export default ButtonGroup;
